<template>
  <div>
    <div class="con">
      <img src="static/img/Vhome_Bg.jpg" class="bg">
      <div class="btnBlock">
        <img v-if="isPC || !isAndroid" src="static/img/IPhoneDownload.png"  class="btn" @click="download_vhome_iphone">
        <img v-if="isPC || isAndroid" src="static/img/AndroidDownload.png" class="btn" @click="download_vhome">
      </div>
    </div>

    <div class="reminder_title" v-if="!isClick && this.isAndroid && (this.isWX || this.isQQ || this.isAlipay)" @click="isClick = true">
      <img src="static/img/pic_arrow.png" class="arrow_bg" style="display: block;">
      <img :src="this.isWX?'static/img/pic_android_literal.png':'static/img/pic_weixin_literal.png'" class="literal_bg" style="display: block;">
    </div>
    <div class="reminder_title" v-if="!isClick && !this.isAndroid && (this.isWX || this.isQQ || this.isAlipay)" @click="isClick = true">
      <img src="static/img/pic_arrow.png" class="arrow_bg" style="display: block;">
      <img :src="'static/img/pic_ios.png'" class="literal_bg" style="display: block;">
    </div>
  </div>


</template>
<script>
  export default {
    data () {
      return {
        isClick: false,
        isAndroid: false,
        isPC: false,
        isWX: false,
        isQQ: false,
        isAlipay: false,
        userAgent: navigator.userAgent
      }
    },
    methods: {
      download_vhome_iphone () {
        console.log('Vhome iphone download')
        setTimeout(function () {
          window.location.href = 'https://itunes.apple.com/cn/app/创维唯家/id1174744453?mt=8'
        }, 3000)
      },
      download_vhome_android () {
        console.log('Vhome android download')
        // window.location.href = 'https://play.google.com/store/apps/details?id=com.starmakerinteractive.starmaker&hl=zh_CN'
        // 直接下载apk
        window.location.href = 'http://dl.cdn.doubimeizhi.com/weijiaapk/vhome-latest.apk'
      },
      download_vhome () {
        console.log('Vhome PC download')
        // 直接下载apk
        window.location.href = 'http://dl.cdn.doubimeizhi.com/weijiaapk/vhome-latest.apk'
      }
    },
    created () {
      console.log('Vhome create ua: ', navigator.userAgent)
      var ua = navigator.userAgent
      this.isWX = !!/MicroMessenger/i.test(ua)
      this.isQQ = !!/QQ\//i.test(ua)
      this.isAlipay = !!/AlipayClient/i.test(ua)
      if (/Android|iPhone|iPad/i.test(ua)) {
        var isAndroid = navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.toLowerCase().indexOf('adr') > -1
        this.isAndroid = isAndroid
        this.isPC = false
        let from = window.location.href
        window.location.href = 'weijia://weijia?from=' + encodeURIComponent(from)
      } else {
        // 如果是PC端打开则直接下载apk文件
        this.isPC = true
      }
    },
    mounted () {
      console.log('mounted')
      document.addEventListener('visibilitychange', function () {
        console.log('visibilitychange hidden: ' + document.hidden)
        // window.location.href = 'weijia://weijia'
      })
    }
  }
</script>
<style>
  .con {
    max-width: 640px;
    position: relative;
    margin: 0 auto;
  }
  .bg {
    width: 100%;
    position: relative;
    display: block;
    margin: 0px;
    padding: 0px;
    border: none;
  }
  .btnBlock {
    /* display: block; */
    display: flex;
    flex-direction: row;
    /* flex-wrap: wrap; */
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    justify-content: space-around;
    background-color: rgba(0, 0, 0, 0.5);
    padding: 1rem;
    margin: 0.5rem 0;
    justify-content: center;
    align-items: center;
    text-align: center;
  }
  .btn {
    height: 3rem;
    /* min-height: 1rem; */
    width: 15rem;
    margin:0 50px;
  }
  .btn1 {
    position: absolute;
    top: 450px;
    left: 40%;
    margin-left: -220px;
  }
  .bg1 {
    width: 250px;
    height: 50px;
  }
  .bg2 {
    position: absolute;
    width: 250px;
    height: 50px;
    top: 0px;
    margin-left: 320px;
  }
  .bg3 {
    position: absolute;
    width: 250px;
    height: 50px;
    /*top: 0px;*/
    margin-left: 160px;
  }
  .reminder_title {
    position: absolute;
    background-color: #000000;
    width: 100%;
    height: 100%;
    text-align: center;
    opacity: 0.86;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }
  .arrow_bg {
    margin-left: 73%;
    width: 80px;
    height: 80px;
  }
  .literal_bg {
    /* width: 350px;
    height: 100px;
    margin-left: 36px; */
    width: 90%;
    height: 15%;
    margin-left: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Vhome.vue